<template>
  <div id="page">
    <div class="flex row">
        <div id="cardsLane" class="topCardGrid">
            <sp-card stripe="" :valor="consolidado || 0" :descricao="$t('profissionaisSaude.cards.total', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="hspm || 0" :descricao="$t('profissionaisSaude.cards.hspm', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="municipal || 0" :descricao="$t('profissionaisSaude.cards.municipal', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="estadual || 0" :descricao="$t('profissionaisSaude.cards.estadual', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="federal || 0" :descricao="$t('profissionaisSaude.cards.federal', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="maisMedicos || 0" :descricao="$t('profissionaisSaude.cards.maisMedicos', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
            <sp-card stripe="" :valor="parceira || 0" :descricao="$t('profissionaisSaude.cards.parceira', {data : 'cardData.dataRef'})" :footerText="dataRef"/>
        </div>
    </div>
    <div class="flex row">
        <div id="chartLane" class="flex chartPanel">
            <sp-360-panel :title="$t('profissionaisSaude.areaAtividade.title')"  :footerText="dataRef">
                <sp-360-chart id="chartAreaAtividade" type="horizontal-bar" :data="chartAreaAtividade.chartData" :options="chartAreaAtividade.options" class=''/>
            </sp-360-panel>
        </div>
        <div id="chartLane" class="flex chartPanel">
            <sp-360-panel :title="$t('profissionaisSaude.organizacoesSocias.title')"  :footerText="dataRef">
                <sp-360-chart id="chartOrganizacoesSociais" type="horizontal-bar" :data="chartOrganizacoesSociais.chartData" :options="chartOrganizacoesSociais.options" class=''/>
            </sp-360-panel>
        </div>
        <div id="chartLane" class="flex chartPanel">
            <sp-360-panel :title="$t('profissionaisSaude.regimeJuridico.title')"  :footerText="dataRef">
                <sp-360-chart id="chartOrganizacoesSociais" type="vertical-bar" :data="chartRegimeJuridico.chartData" :options="chartRegimeJuridico.options" class=''/>
            </sp-360-panel>
        </div>
    </div>
    <div class="flex row">
        <div id="chartLane" class="flex ">
            <sp-360-panel :title="$t('profissionaisSaude.entradasSaidas.title')"  :footerText="dataRef">
                <sp-360-chart id="chartOrganizacoesSociais" type="donut" :data="chartSaidasEntradas.chartData" :options="chartSaidasEntradas.options" class='smallChartPanel'/>
            </sp-360-panel>
        </div>
        <div id="chartLane" class="flex ">
            <sp-360-panel :title="$t('profissionaisSaude.sexoBiologico.title')"  :footerText="dataRef">
                <sp-360-chart id="chartOrganizacoesSociais" type="donut" :data="chartSexoBiologico.chartData" :options="chartSexoBiologico.options" class='smallChartPanel'/>
            </sp-360-panel>
        </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import * as d3 from 'd3'

export default {
  name: 'fila-consultas',
  mixins: [],
  components: { SpCard, Sp360Chart, Sp360Panel, Multiselect, Sp360DataTable },

  data: function () {
    return {
      consolidado: 0,
      hspm: 0,
      municipal: 0,
      estadual: 0,
      federal: 0,
      maisMedicos: 0,
      parceira: 0,
      chartAreaAtividade: { chartData: {}, options: {} },
      chartOrganizacoesSociais: { chartData: {}, options: {} },
      chartRegimeJuridico: { chartData: {}, options: {} },
      chartSaidasEntradas: { chartData: {}, options: {} },
      chartSexoBiologico: { chartData: {}, options: {} },
      dataRef: 0,
    }
  },

  created () {
    Promise.all([
      // 0 ~ 4
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'CONSOLIDADO' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'VINCULO_CONTRATACAO' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'APOSENTADORIAS' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'AREA_ATIVIDADE' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'ATENDIMENTOS_EXPROF' }),
      // 5 ~ 10
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'COORDENADORIA' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'ENTRADAS' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'NIVEL_CATEGORIA' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'ORGANIZACAO_SOCIAL' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'REGIME_JURIDICO' }),
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'SAIDAS' }),
      // 11 ~
      this.$store.dispatch('saude/quantitativosDeProfissionaisPorQualificador', { qualificador: 'SEXO_BIOLOGICO' }),
    ]).then(respostas => {
      console.log(respostas)
      this.dataRef = this.$t('rodape.fonteData', { fonte: respostas[0].data.sigla_orgao + '/' + respostas[0].data.fonte, data: new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR') })
      this.colors = _.shuffle(CorUtils.getVetorCoresPorTom('medio'))

      this.consolidado = respostas[0].data.data[0].quantidade_profissionais
      this.hspm = respostas[1].data.data[0].quantidade_profissionais
      this.municipal = respostas[1].data.data[1].quantidade_profissionais
      this.estadual = respostas[1].data.data[2].quantidade_profissionais
      this.federal = respostas[1].data.data[3].quantidade_profissionais
      this.maisMedicos = respostas[1].data.data[4].quantidade_profissionais
      this.parceira = respostas[1].data.data[5].quantidade_profissionais

      this.chartAreaAtividade.chartData = this.montarGraficoAreaAtividade(_.orderBy(respostas[3].data.data, 'quantidade_profissionais', ['desc']))
      this.chartAreaAtividade.options = this.optionsgraficoHorizontalBar(this.$t('profissionaisSaude.areaAtividade.yLabel', this.$t('profissionaisSaude.areaAtividade.xLabel'), ))

      this.chartOrganizacoesSociais.chartData = this.montarGraficoOrganizacoesSociais(_.orderBy(respostas[8].data.data, 'quantidade_profissionais', ['desc']))
      this.chartOrganizacoesSociais.options = this.optionsgraficoHorizontalBar(this.$t('profissionaisSaude.organizacoesSocias.yLabel'), this.$t('profissionaisSaude.organizacoesSocias.xLabel'))

      this.chartRegimeJuridico.chartData = this.montarGraficoRegimeJuridico(_.orderBy(respostas[9].data.data, 'quantidade_profissionais', ['desc']))
      this.chartRegimeJuridico.options = this.optionsgraficoVerticalBar(this.$t('profissionaisSaude.regimeJuridico.xLabel'), this.$t('profissionaisSaude.regimeJuridico.yLabel'))

      this.entradas = respostas[6].data.data
      this.saidas = respostas[10].data.data

      this.chartSaidasEntradas.chartData = this.montarGraficoSaidasEntradas([this.saidas[0], this.entradas[0]])
      this.chartSaidasEntradas.options = this.optionsgraficoDonut()

      this.chartSexoBiologico.chartData = this.montarGraficoSexoBiologico(_.orderBy(respostas[11].data.data, 'quantidade_profissionais', ['desc']))
      this.chartSexoBiologico.options = this.optionsgraficoDonut()
    })
  },

  methods: {
    montarGraficoAreaAtividade (dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: 'Numero de profissionais',
        backgroundColor: CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.2,
        barPercentage: 1.0,
        // yAxisID: 'y-axis-1'
      }
      dados.forEach(el => {
        chartData.labels.push(el.tipo_variaveis)
        dataset.data.push(el.quantidade_profissionais)
      })
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoOrganizacoesSociais (dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: 'Numero de profissionais',
        backgroundColor: CorUtils.getCorPorNomeSp360(CorUtils.AMARELO_MEDIO),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        // yAxisID: 'y-axis-1'
      }
      dados.forEach(el => {
        chartData.labels.push(el.tipo_variaveis)
        dataset.data.push(el.quantidade_profissionais)
      })

      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoRegimeJuridico (dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: 'Numero de profissionais',
        backgroundColor: this.colors.shift(),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.2,
        barPercentage: 1.0,
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let percentage = MethGlob.formataPercentual(value * 100 / this.consolidado) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          // anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      dados.forEach(el => {
        chartData.labels.push(el.tipo_variaveis)
        dataset.data.push(el.quantidade_profissionais)
      })
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoSaidasEntradas (dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: this.$t('profissionaisSaude.entradasSaidas.xLabel'),
        backgroundColor: this.colors.splice(0, 3),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.2,
        barPercentage: 1.0,
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let percentage = MethGlob.formataPercentual(value * 100 / this.consolidado) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      dados.forEach(el => {
        chartData.labels.push(el.tipo_variaveis)
        dataset.data.push(el.quantidade_profissionais)
      })
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoSexoBiologico (dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: this.$t('profissionaisSaude.sexoBiologico.xLabel'),
        backgroundColor: this.colors.splice(0, 3),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.2,
        barPercentage: 1.0,
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let percentage = MethGlob.formataPercentual(value * 100 / this.consolidado) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      dados.forEach(el => {
        chartData.labels.push(el.tipo_variaveis === 'F' ? 'Feminino' : 'Masculino')
        dataset.data.push(el.quantidade_profissionais)
      })
      chartData.datasets.push(dataset)
      return chartData
    },

    optionsgraficoDonut () {
      return {
        plugins: { datalabels: {} },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              return `${chart.labels[tooltipItem.index]} : ${chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR')}`
            },
          },
        },

      }
    },

    optionsgraficoHorizontalBar (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = tooltipItem.yLabel.join(' ') + '  ' || ''
              } else {
                label = tooltipItem.yLabel + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.xLabel)
              return label
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              // fontSize: 8,
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          xAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },
            type: 'logarithmic',
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          },
          ],
        },
      }
    },

    optionsgraficoVerticalBar (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
              let label = tooltipItem[0].xLabel
              return label
            },
            label: (tooltipItem, chart) => {
              console.log(tooltipItem.xLabel)
              return tooltipItem.xLabel + ' - ' + tooltipItem.yLabel.toLocaleString('pt-BR')
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            // type: 'logarithmic',
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              maxTicksLimit: 7,
              beginAtZero: true,
              autoSkip: false,
              callback: (value) => value.toLocaleString('pt-BR'),
            },
          }],
          xAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },

            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          },
          ],
        },
      }
    },

  },

}
</script>

<style lang="scss" scoped>
.chartPanel{
  .va-chart {
    max-height: 30rem;
  }
    width: 100%;
}
.smallChartPanel{
    max-height: 20rem;
}
</style>
